import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId, scrollToTop } from "../lib/scroll";

const LINKS = [
  { id: "banda", label: "El Grupo" },
  { id: "musica", label: "Música" },
  { id: "conciertos", label: "Conciertos" },
  { id: "directo", label: "Directo" },
  { id: "carteleria", label: "Cartelería" },
  { id: "galeria", label: "Galería" },
  { id: "prensa", label: "Prensa" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), open ? 250 : 0);
  };

  return (
    <>
      <header
        className={`fixed top-0 inset-x-0 z-[70] transition-all duration-500 ${
          scrolled ? "bg-ink/85 backdrop-blur-md border-b border-gold/10" : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="mx-auto max-w-[1600px] px-6 sm:px-12 lg:px-24 h-16 md:h-20 flex items-center justify-between">
          <button
            data-testid="nav-logo-button"
            onClick={scrollToTop}
            className="font-sans text-base md:text-lg font-light tracking-[0.3em] text-gold"
          >
            CUARTO<span className="font-semibold text-cream">BOLERO</span>
          </button>
          <nav className="hidden lg:flex items-center gap-6">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="group relative text-[13px] uppercase tracking-[0.18em] text-sand hover:text-cream transition-colors"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" />
              </button>
            ))}
            <button
              data-testid="nav-cta-button"
              onClick={() => go("contratacion")}
              className="ml-2 rounded-full border border-gold/50 px-5 py-2 text-[12px] uppercase tracking-[0.2em] text-gold hover:bg-gold hover:text-ink transition-all duration-300"
            >
              Contratación
            </button>
          </nav>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-cream p-2"
            onClick={() => setOpen(true)}
            aria-label="Abrir menú"
          >
            <Menu size={26} strokeWidth={1.5} />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-menu"
            className="fixed inset-0 z-[80] bg-ink/[0.98] backdrop-blur-xl flex flex-col"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex items-center justify-between px-6 h-16">
              <span className="font-sans text-base font-light tracking-[0.3em] text-gold">
                CUARTO<span className="font-semibold text-cream">BOLERO</span>
              </span>
              <button data-testid="nav-mobile-close" className="text-cream p-2" onClick={() => setOpen(false)} aria-label="Cerrar menú">
                <X size={28} strokeWidth={1.5} />
              </button>
            </div>
            <nav className="flex-1 flex flex-col justify-center px-8 gap-1">
              {[...LINKS, { id: "contratacion", label: "Contratación" }, { id: "contacto", label: "Contacto" }].map((l, i) => (
                <motion.button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="text-left font-serif text-4xl sm:text-5xl text-cream/90 hover:text-gold py-2 transition-colors"
                  initial={{ opacity: 0, x: -24 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.08 + i * 0.06, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                >
                  {l.label}
                </motion.button>
              ))}
            </nav>
            <p className="px-8 pb-10 text-[11px] uppercase tracking-[0.3em] text-mute">Boleros · Emoción · Música en directo</p>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
